module.exports = __webpack_public_path__ + "img/676.108ea414.jpg";